module.exports = __webpack_public_path__ + "static/media/cat6.f7bddbe1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat6.jpeg
// module id = 38
// module chunks = 0